import { createQueryKeys } from '@lukemorales/query-key-factory'

export const invites = createQueryKeys('invites', {
  points: null,
  details: (inviteId: string) => ({
    queryKey: [inviteId],
  }),
  list: null,
  infiniteList: (params: { completed?: boolean; limit?: number; skip?: number }) => ['infiniteList', params],
  creditStatus: null,
})
